const snack = require('../snack/snack') // Ajusta la ruta de tu snack

export function start(detail, phpFile) {

    const infNewData = getFormData(detail)

    const controller = new AbortController()
    const timeout = setTimeout(() => { controller.abort() }, 30000)

    const options = {
        method: 'POST',
        body: infNewData,
        signal: controller.signal,
        credentials: 'same-origin'
    }

    return fetch(`./${phpFile}`, options)
        .then(handleErrors)
        .then(result => {
            clearTimeout(timeout)
            return result.json()
        })
        .then(parsedResult => {
            return parsedResult
        })
        .catch(err => {
            clearTimeout(timeout)
            console.error('Error en Chat Request: ', err)
            throw err
        })
}

function handleErrors(response) {
    if (!response.ok) { throw Error(response.statusText) }
    return response;
}

function getFormData(object) {
    const formData = new FormData()
    Object.keys(object).forEach(key => {
        const value = typeof object[key] === 'object' ? JSON.stringify(object[key]) : object[key]
        formData.append(key, value)
    })
    return formData
}